import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#0597A3"
      d="M12.372 25.303a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#0597A3"
      d="M20.744 81.472a8.117 8.117 0 0 0 8.117 8.117h55.601c6.156 0 11.147-4.99 11.147-11.147V38.788H20.744z"
    />
    <path
      fill="#00D8D8"
      d="M87.493 22.746H28.862a8.117 8.117 0 0 0-8.117 8.117v7.926h74.864v-7.926a8.117 8.117 0 0 0-8.117-8.117z"
    />
    <path
      fill="#001A43"
      d="M50 68.592c0-4.47-3.212-7.347-8.182-7.347h-3.636c-2.727 0-2.727-1.2-2.727-1.837s0-1.837 2.727-1.837h7.879c1.503 0 2.727-1.236 2.727-2.755s-1.224-2.755-2.727-2.755h-3.334v-.306C42.727 50.237 41.503 49 40 49s-2.727 1.237-2.727 2.755v.343c-4.449.33-7.273 3.135-7.273 7.31 0 4.47 3.212 7.347 8.182 7.347h3.636c2.727 0 2.727 1.2 2.727 1.837s0 1.837-2.727 1.837H33.94c-1.503 0-2.727 1.236-2.727 2.755s1.224 2.755 2.727 2.755h3.334v.306C37.273 77.763 38.497 79 40 79s2.727-1.237 2.727-2.755v-.343c4.449-.33 7.273-3.135 7.273-7.31"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M63.899 96.005V56.093a.763.763 0 0 1 1.182-.638l4.633 3.04a.76.76 0 0 0 .876-.026l5.133-3.83a.76.76 0 0 1 .891-.017l5.772 3.995c.262.182.61.181.871-.002l5.702-3.98a.76.76 0 0 1 .913.03l4.899 3.904a.76.76 0 0 0 .904.035l4.606-3.118a.763.763 0 0 1 1.191.632V95.92a.763.763 0 0 1-1.208.62l-4.357-3.126a.76.76 0 0 0-.878-.009l-5.392 3.707a.76.76 0 0 1-.859.004l-5.525-3.724a.76.76 0 0 0-.859.004l-5.425 3.726a.76.76 0 0 1-.84.016l-5.555-3.514a.76.76 0 0 0-.822.004l-4.674 3.02a.764.764 0 0 1-1.178-.642z"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M72.085 71.678a2.25 2.25 0 0 1 2.25-2.25h16.83a2.25 2.25 0 0 1 0 4.5h-16.83a2.25 2.25 0 0 1-2.25-2.25M72.085 80.046a2.25 2.25 0 0 1 2.25-2.25h16.83a2.25 2.25 0 0 1 0 4.5h-16.83a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M31.799 5.738a1.5 1.5 0 0 1 0 2.121l-9.994 9.994a1.5 1.5 0 1 1-2.122-2.12l9.994-9.995a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M19.683 5.738a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.5 1.5 0 1 1-2.122 2.122l-9.994-9.995a1.5 1.5 0 0 1 0-2.12M106.066 37.5a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V39a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M97.5 46.066a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H99a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M111.046 69.294a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M11.826 84.036a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconDigitalReceiptsInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconDigitalReceiptsInverted);
export default Memo;
